import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentFormComponent } from './document-form/document-form.component';
import { DocumentViewComponent } from './document-view/document-view.component';
import { DocumentRountingModule } from './document-routing-module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { AngularMaterialModule } from '../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    DocumentFormComponent,
    DocumentViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DocumentRountingModule,
    AngularMaterialModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
  ]
})
export class DocumentModule { 
    title = "Document Master"
}
